// test2132
(2132 && 0);
